<template>
  <v-main>
    <v-container fluid class="py-8 px-6">
      <div class="d-flex justify-space-between align-center mb-6">
        <div
          class="animated-title text-h4 font-weight-light refined-entrance mb-5 d-flex align-center"
        >
          Proyectos
        </div>

        <div class="btn-group-responsive">
          <v-btn
            elevation="1"
            rounded
            medium
            dark
            @click="handleShowProjectForm"
            v-if="projects.length > 0"
          >
            <v-icon left size="20">mdi-plus</v-icon>
            <span>Crear proyecto</span>
          </v-btn>

          <v-btn
            elevation="1"
            rounded
            medium
            dark
            @click="handleShowQuoteModal"
            v-if="projects.length > 0"
          >
            <v-icon left size="20">mdi-plus</v-icon>
            <span>Cotizar material</span>
          </v-btn>
        </div>
      </div>

      <div v-if="isMobileOrTablet">
        <!-- 3.1. Los propios tabs -->
        <v-tabs
          v-model="mobileTab"
          background-color="#1d1d1f"
          grow
          class="v-tab-mobile mb-6"
          style="border-radius: 30px !important; border: 1px solid #fff"
          color="#fff"
          slider-color="transparent"
          slider-size="0"
        >
          <v-tab key="tab-0" active-class="tab--active-bg" style="color: #fff"
            >Proyectos</v-tab
          >
          <v-tab key="tab-1" active-class="tab--active-bg" style="color: #fff"
            >Cotizaciones</v-tab
          >
        </v-tabs>

        <v-tabs-items
          v-model="mobileTab"
          style="
            background: none !important;
            padding: 0 !important;
            margin: 0 !important;
          "
        >
          <v-tab-item key="item-0" style="padding: 0 !important">
            <v-row class="fill-height" style="min-height: calc(100vh - 220px)">
              <v-col
                cols="12"
                class="d-flex flex-column align-start"
                style="padding: 0 !important"
              >
                <v-col cols="12" md="6" class="d-flex flex-column align-start">
                  <ProjectCard
                    v-for="(project, index) in projects"
                    :key="index"
                    :project="project"
                    :phases="phasesAll"
                    :types="types"
                    class="project-col mb-4"
                    style="
                      width: 100%;
                      height: auto;
                      padding: 16px;
                      border-radius: 8px;
                      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
                    "
                    @editProject="
                      selectedProject = project;
                      showEditModal = true;
                    "
                    @handleMakeQuote="handleMakeQuote"
                    @openProjectDetailModal="openProjectDetailModal"
                    @handleAssignPurchases="handleAssignPurchases"
                    @close="closeProjectDetailModal"
                    @showProjectPurchases="showProjectPurchases"
                  />

                  <v-btn
                    @click="handleShowProjectForm"
                    :elevation="2"
                    class="pa-5 project-card premium-card w-100 d-flex justify-center align-center"
                    style="
                      min-height: 120px;
                      width: 100%;
                      font-size: 1.2em;
                      border-radius: 8px;
                      cursor: pointer;
                      color: #fff;
                      border: 1px solid white;
                      background-color: #000;
                    "
                  >
                    + Crear proyecto
                  </v-btn>
                </v-col>
              </v-col>
            </v-row>
          </v-tab-item>

          <v-tab-item key="item-1">
            <v-row class="fill-height" style="min-height: calc(100vh - 220px)">
              <v-col cols="12" class="d-flex flex-column justify-space-between">
                <QuotesComponent
                  :quotes="quotes"
                  :hasProjects="hasProjects"
                  @showProjectForm="showEditModal = true"
                  @showQuoteForm="showQuoteModal = true"
                />
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </div>
      <v-row v-else class="fill-height" style="min-height: calc(100vh - 160px)">
        <v-col
          cols="12"
          md="6"
          class="d-flex flex-column align-start project-scroll-col"
        >
          <div
            v-if="projects.length == 0"
            class="project-col mb-4 mango-banner"
            style="
              padding: 2em;
              min-height: 120px;
              width: 100%;
              font-size: 1.2em;
              border-radius: 8px;
              cursor: pointer;
              color: #fff;
              border: 1px solid transparent;
            "
          >
            <div
              class="text-h7 font-weight-bold"
              style="text-shadow: 0 1px 4px rgba(0, 0, 0, 0.2)"
            >
              Lleva el control total de tu obra, sin complicaciones
            </div>
            <p
              class="mt-2"
              style="
                font-size: 0.8em;
                text-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
              "
            >
              Registrá tu primer proyecto para cotizar materiales con múltiples
              proveedores, organizar tus compras y
              <b>acceder a condiciones de crédito preferenciales.</b>
            </p>
          </div>

          <ProjectCard
            v-for="(project, index) in projects"
            :key="index"
            :project="project"
            :phases="phasesAll"
            :types="types"
            class="project-col"
            style="
              width: 100%;
              height: auto;
              padding: 16px;
              border-radius: 8px;
              box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
            "
            @editProject="
              selectedProject = project;
              showEditModal = true;
            "
            @handleMakeQuote="handleMakeQuote"
            @openProjectDetailModal="openProjectDetailModal"
            @handleAssignPurchases="handleAssignPurchases"
            @close="closeProjectDetailModal"
            @showProjectPurchases="showProjectPurchases"
          />

          <v-btn
            @click="showEditModal = true"
            :elevation="2"
            class="pa-5 project-card premium-card w-100 d-flex justify-center align-center"
            style="
              min-height: 100px;
              width: 100%;
              font-size: 1.2em;
              border-radius: 8px;
              cursor: pointer;
              color: #fff;
              border: 1px solid rgb(106, 106, 106);
              background-color: #000;
            "
          >
            + Crear proyecto
          </v-btn>
        </v-col>

        <v-col
          cols="12"
          md="6"
          class="d-flex flex-column justify-space-between"
        >
          <QuotesComponent
            :quotes="quotes"
            :hasProjects="hasProjects"
            @showProjectForm="showEditModal = true"
            @showQuoteForm="showQuoteModal = true"
            @openDetail="openQuoteDetail"
          />
        </v-col>
      </v-row>

      <DialogProjectForm
        :key="dialogKey"
        :visible="showEditModal"
        :project="selectedProject"
        :phasesAll="phasesAll"
        :types="types"
        @close="closeEditModal"
        @projectUpdated="updateProject"
      />

      <DialogQuoteForm
        :projects="projects"
        :visible="showQuoteModal"
        :selectedProject="selectedProjectQuote"
        @close="
          showQuoteModal = false;
          selectedProject = null;
          selectedProjectQuote = null;
        "
        @quoteUpdate="quoteUpdate"
      />

      <ProjectDetailView
        v-if="showDetailModal && currentProjectId"
        v-model="showDetailModal"
        :project-id="currentProjectId"
        @input="showDetailModal = $event"
        @close="closeProjectDetailModal"
      />

      <QuotesDetailView
        v-if="showQuotesDetailModal && currentQuoteId"
        v-model="showQuotesDetailModal"
        :quote-id="currentQuoteId"
        @input="showQuotesDetailModal = $event"
        @close="closeQuoteDetailModal"
      />

      <DialogAssignPurchases
        :visible="showAssignPurchaseModal"
        :project="selectedProject"
        @close="closeDialogAssignPurchases"
        @handleMakeQuote="handleMakeQuote"
        @projectsUpdate="projectsUpdate"
      />

      <DialogTablePurchases
        :visible="showDialogTablePurchases"
        :project="selectedProject"
        @close="
          showDialogTablePurchases = false;
          selectedProject = null;
        "
        @handleMakeQuote="handleAssignPurchases"
      />
    </v-container>
    <transition name="fade" mode="out-in">
      <LoaderMango v-if="loading" key="loader" />
    </transition>
  </v-main>
</template>

<script>
import DialogProjectForm from "@/components/projects/DialogProjectForm.vue";
import QuotesComponent from "@/components/projects/QuotesComponent.vue";
import DialogQuoteForm from "@/components/projects/DialogQuoteForm.vue";
import LoaderMango from "@/components/projects/LoaderMango.vue";
import ProjectService from "@/services/ProjectService";
import { phases as phasesAll, types } from "@/config/projects/data";
import ProjectDetailView from "@/components/projects/ProjectDetailView.vue";
import QuotesDetailView from "@/components/projects/QuotesDetailView.vue";
import DialogAssignPurchases from "@/components/projects/DialogAssignPurchases.vue";
import DialogTablePurchases from "@/components/projects/assignPurchases/DialogTablePurchases.vue";
import QuoteService from "@/services/quoteService";
import ProjectActivitiesService from "../services/projectActivitiesService";

export default {
  name: "ProjectsView",
  components: {
    DialogProjectForm,
    DialogQuoteForm,
    ProjectCard: () => import("@/components/ProjectCard.vue"),
    QuotesComponent,
    LoaderMango,
    ProjectDetailView,
    QuotesDetailView,
    DialogAssignPurchases,
    DialogTablePurchases,
  },

  data() {
    return {
      quotes: [],
      projects: [],
      showEditModal: false,
      showQuoteModal: false,
      selectedProject: {},
      selectedProjectQuote: {},
      dialogKey: 0,
      mobileTab: 0,
      loading: true,
      phasesAll,
      types,
      showDetailModal: false,
      showQuotesDetailModal: false,
      showAssignPurchaseModal: false,
      currentProjectId: null,
      currentQuoteId: null,
      showDialogTablePurchases: false,
    };
  },

  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  },

  async created() {
    await this.fetchProjects();
    await this.getQuotes();

    const { name, params } = this.$route;
    if (name === "quotes-detail" && params.id) {
      this.currentQuoteId = params.id;
      this.showQuotesDetailModal = true;
    }

    this.updateQuotePhone();
  },

  methods: {
    async fetchProjects() {
      try {
        const response = await ProjectService.getProjectsWithTotals();
        if (response.ok) {
          const projects = await response.json();
          this.projects = projects;
        } else {
          console.error("Error al obtener proyectos:", response.status);
        }
      } catch (error) {
        console.error("Error en la solicitud:", error);
      }
    },

    async getQuotes() {
      try {
        const response = await QuoteService.get();
        if (response.ok) {
          const quotes = await response.json();
          this.quotes = quotes;
        } else {
          console.error("Error al obtener cotizaciones:", response.status);
        }
      } catch (error) {
        console.error("Error en la solicitud:", error);
      }
    },

    async handleShowQuoteModal() {
      this.showQuoteModal = true;

      await ProjectActivitiesService.create({
        event: "click_create_quote",
      });
    },

    async handleShowProjectForm() {
      this.showEditModal = true;

      await ProjectActivitiesService.create({
        event: "click_create_project",
      });
    },

    closeEditModal() {
      this.showEditModal = false;
      this.selectedProject = null;
    },

    updateProject(updatedProject) {
      const index = this.projects.findIndex((p) => p.id === updatedProject.id);
      if (index !== -1) {
        this.$set(this.projects, index, updatedProject);
      } else {
        this.projects.unshift(updatedProject);
      }
    },

    async quoteUpdate() {
      await this.getQuotes();
    },

    async projectsUpdate() {
      await this.fetchProjects();
    },

    getColor(estado) {
      switch (estado.toLowerCase()) {
        case "pendiente":
          return "orange lighten-1";
        case "cotizada":
          return "green lighten-1";
        case "sin respuesta":
          return "blue-grey lighten-1";
        default:
          return "grey lighten-1";
      }
    },

    getIcon(estado) {
      switch (estado.toLowerCase()) {
        case "pendiente":
          return "mdi-clock-outline";
        case "cotizada":
          return "mdi-check-circle-outline";
        case "sin respuesta":
          return "mdi-help-circle-outline";
        default:
          return "mdi-alert-circle-outline";
      }
    },

    logout() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.$router.push({ name: "dashboard-customer" });
      }, 2000);
    },

    handleMakeQuote(project) {
      this.selectedProjectQuote = project;
      this.showQuoteModal = true;
    },

    handleAssignPurchases(project) {
      if (this.showAssignPurchaseModal) {
        this.showAssignPurchaseModal = false;
        setTimeout(() => {
          this.selectedProject = project;
          this.showAssignPurchaseModal = true;
        }, 100);
      } else {
        this.selectedProject = project;
        this.showAssignPurchaseModal = true;
      }
    },

    openProjectDetailModal(id) {
      this.currentProjectId = id;
      this.showDetailModal = true;
    },
    closeProjectDetailModal() {
      this.currentProjectId = null;
      this.showDetailModal = false;
    },

    closeQuoteDetailModal() {
      this.currentQuoteId = null;
      this.showQuotesDetailModal = false;
    },

    closeDialogAssignPurchases() {
      this.selectedProject = null;
      this.showAssignPurchaseModal = false;
    },

    showProjectPurchases(project) {
      this.selectedProject = project;
      this.showDialogTablePurchases = true;
    },

    // Set contact_phone (customers table) like quote phone default.
    updateQuotePhone() {
      const quotePhone = this.$ProjectsManager.getQuotePhone();

      if (!quotePhone) {
        const phone = this.$UserManager.getPhone();
        this.$ProjectsManager.setQuotePhone(phone);
      }
    },

    openQuoteDetail(quoteId) {
      this.$router
        .push({ name: "quotes-detail", params: { id: quoteId } })
        .catch(() => {});
      this.currentQuoteId = quoteId;
      this.showQuotesDetailModal = true;
    },
  },

  computed: {
    hasProjects() {
      return this.projects.length > 0;
    },

    isMobileOrTablet() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },

  watch: {
    $route(to) {
      if (to.name === "project-detail" && to.params.id) {
        this.currentProjectId = to.params.id;
        this.showDetailModal = true;
        return;
      }

      if (to.name === "quotes-detail" && to.params.id) {
        this.currentQuoteId = to.params.id;
        this.showQuotesDetailModal = true;
        return;
      }

      this.showDetailModal = false;
      this.showQuotesDetailModal = false;

      this.currentProjectId = null;
      this.currentQuoteId = null;
    },
  },
};
</script>

<style scoped>
.btn-group-responsive {
  display: flex;
  flex-direction: row;
  gap: 12px;
}

.btn-group-responsive span {
  text-transform: uppercase;
  font-size: 0.8em;
  font-weight: 600;
}

@media (max-width: 960px) {
  .btn-group-responsive {
    display: flex;
    justify-content: space-between;
  }

  .btn-group-responsive .create-project-btn {
    flex: 0 0 auto;
    max-width: 100%;
    width: auto;
  }
}

.transition-logo {
  width: 50px !important;
}

@media (max-width: 998px) {
  .transition-logo {
    width: 30px !important;
  }
}

main {
  background-color: #fff !important;
}

.refined-entrance {
  opacity: 0;
  transform: translateX(-20px);
  animation: refinedFadeIn 0.6s ease-out forwards;
  will-change: opacity, transform;
}

@keyframes refinedFadeIn {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.animated-title {
  /* color: #1d1d1f; */
  color: #000;
  text-align: left;
  letter-spacing: 0.5px;
  /* font-family: 'Inter', 'SF Pro Display', 'Roboto', sans-serif; */
}

.create-project-btn {
  font-weight: 500;
  text-transform: lowercase !important;
  font-family: "Inter", sans-serif;
  color: #fff;
  border: 1px solid #d0d0d0;
  /* border-radius: 12px; */
  padding: 10px 16px;
  transition: all 0.25s ease;
  /* box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06); */
  background-color: white;
  letter-spacing: 1px;
}

.create-project-btn:hover {
  background-color: #f5f5f5;
  border-color: #c6c6c6;
}

.d-flex.justify-space-between.align-center.mb-6 {
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 0;
}

@media (max-width: 960px) {
  .animated-title {
    font-size: 1.6rem !important;
  }

  .create-project-btn {
    font-size: 0.85rem;
    padding: 8px 12px;
    border-radius: 10px;
    margin-left: 0 !important;
    width: 100%;
    justify-content: center;
  }

  .d-flex.justify-space-between.align-center.mb-6 {
    flex-direction: column;
    align-items: stretch !important;
    gap: 12px;
  }
}
.summary-card {
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding-bottom: 2rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
}

.summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.summary-card .v-card-title {
  font-weight: 600;
  letter-spacing: 0.8px;
  color: #6b6b6b;
  text-transform: uppercase;
}

.summary-card .v-card-text {
  font-size: 0.95rem;
  color: #3c3c3c;
  line-height: 1.4rem;
  font-weight: light !important;
}
.project-scroll-col {
  gap: 12px;
  overflow-y: auto;
  max-height: calc(100vh - 160px);
  position: relative;
  padding-right: 8px;
}
.project-scroll-col::after {
  display: none;
}

/* Scrollbar personalizado para WebKit (Chrome, Edge, Safari) */
.project-scroll-col::-webkit-scrollbar {
  width: 8px;
  height: 5px !important;
}

.project-scroll-col::-webkit-scrollbar-track {
  background: transparent;
}

.project-scroll-col::-webkit-scrollbar-thumb {
  background-color: #c7c7c7; /* Gris claro */
  border-radius: 4px;
  border: 2px solid transparent;
  background-clip: content-box;
}

/* Opcional: hover más visible */
.project-scroll-col::-webkit-scrollbar-thumb:hover {
  background-color: #aaa;
}

.project-scroll-col {
  gap: 12px;
  overflow-y: auto;
  max-height: calc(100vh - 160px);
  position: relative;

  /* Oculta el scrollbar por defecto (WebKit) */
}
/* .project-scroll-col::-webkit-scrollbar {
  width: 6px;
  opacity: 0;
} */

/* Thumb y track ocultos por defecto */
.project-scroll-col::-webkit-scrollbar-thumb,
.project-scroll-col::-webkit-scrollbar-track {
  background-color: transparent;
}

/* Al hacer hover, mostrar el scrollbar */
.project-scroll-col:hover::-webkit-scrollbar-thumb {
  background-color: #ccc;
}

.project-scroll-col:hover::-webkit-scrollbar-track {
  background-color: transparent;
}

.project-scroll-col:hover::-webkit-scrollbar {
  opacity: 1;
}

.v-tab-mobile.v-tab.v-tab--active::before {
  border-radius: 20px !important;
}
</style>

<!-- Estas reglas deberían ir SIN scoped para que afecten a <transition> -->
<style>
/* Definimos la animación de fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.tab--active-bg {
  background-color: rgba(255, 255, 255, 0.2) !important;
  border-radius: 20px;
}

.mango-banner {
  background: linear-gradient(
    135deg,
    #a83232,
    #cc7722,
    #8e44ad,
    #3b7a57,
    #ffa000
  );
  background-size: 500% 500%;
  animation: mangoGradientDark 15s ease infinite;
  color: #fff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
  backdrop-filter: brightness(0.8);
}

@keyframes mangoGradientDark {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
